import { merge } from 'lodash';

export const mergeConfigs = ({ dbConfig, serverConfig }) => merge(dbConfig, serverConfig);
